import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
export const TerminalModeContext = createContext(false);
export const useTerminalPresentation = () => useContext(TerminalModeContext);
export function useTerminalMode() {
  const location = useLocation();
  const initial = new URLSearchParams(location.search).get("terminal") === "1";
  const [terminal, setTerminal] = useState(initial);
  useEffect(() => {
    if (new URLSearchParams(location.search).get("terminal") === "1") {
      setTerminal(true);
    }
  }, [location.key, location.search]);
  function close() {
    setTerminal(false);
  }
  function open() {
    setTerminal(true);
  }
  return { terminal, open, close };
}
